import { render, staticRenderFns } from "./optional-products.vue?vue&type=template&id=06f86679&scoped=true&"
import script from "./optional-products.vue?vue&type=script&lang=js&"
export * from "./optional-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f86679",
  null
  
)

export default component.exports